<template>
    <div id="123" class="flex flex-none gap-2 justify-end py-3 text-right">
        <span v-if="showSelectedCounter"> Выбрано элементов: {{ selectedRows }} </span>
        <span> Всего элементов: {{ totalCount }} </span>
    </div>
</template>

<script>
export default {
    name: 'footerGrid',
};
</script>

<script setup>
import { ref } from 'vue';

defineProps({
    totalCount: {
        type: Number,
        default: () => 0,
    },
    showSelectedCounter: {
    type: Boolean,
    default: true,
  },

});

const selectedRows = ref(0);

const selectRows = count => {
    selectedRows.value = count;
};

defineExpose({
    selectRows,
    selectedRows,
});
</script>

<style scoped>
:deep(.dx-menu-item-content) {
    display: flex;
    align-items: center;
}
</style>
